import React, { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Header } from "./Header";
import { Footer } from "./Footer";

// Loading component
function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>
  );
}

export function MainLayout() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const isRtl = i18n.dir() === "rtl";

  // Paths that should hide header/footer
  const hideHeaderFooter = ["/login", "/register", "/order-success"].includes(
    location.pathname,
  );
  const hideFooter =
    hideHeaderFooter ||
    ["/checkout", "/dashboard"].some((path) =>
      location.pathname.startsWith(path),
    );

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col page-shell">
      {/* Header */}
      {!hideHeaderFooter && <Header />}

      {/* Main content */}
      <main className="flex-1 pt-0 md:pt-24">
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </main>

      {/* Footer */}
      {!hideFooter && <Footer />}

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/529985505030"
        target="_blank"
        rel="noopener noreferrer"
        className={`fixed bottom-6 z-50 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl group ${
          isRtl ? "left-6" : "right-6"
        }`}
        aria-label="Contact us on WhatsApp"
      >
        <MessageCircle className="w-6 h-6" />
        <span
          className={`absolute top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none ${
            isRtl ? "left-full ml-3" : "right-full mr-3"
          }`}
        >
          Chat with us
        </span>
      </a>
    </div>
  );
}
